// extracted by mini-css-extract-plugin
export var body = "_mj-8";
export var button = "_mj-0";
export var closeButton = "_mj-5";
export var content = "_mj-3";
export var empty = "_mj-f";
export var grid = "_mj-c";
export var header = "_mj-4";
export var icon = "_mj-1";
export var option = "_mj-d";
export var optionSelected = "_mj-e";
export var overlay = "_mj-2";
export var searchIcon = "_mj-a";
export var searchInput = "_mj-b";
export var searchWrapper = "_mj-9";
export var title = "_mj-6";
export var visuallyHidden = "_mj-7";